import { render, staticRenderFns } from "./CliE_Addresses_List.vue?vue&type=template&id=65612b72"
import script from "./CliE_Addresses_List.vue?vue&type=script&lang=js"
export * from "./CliE_Addresses_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports